module.exports = __webpack_public_path__ + "static/media/Grupo 4591.1b70815c.svg";